import clsx from "clsx";
import Layout from "components/generics/Layout";
import { getPressMediaContent } from "./api";
import ForQueryBox from "components/generics/ForQueryBox";
import BlueFooter from "components/styledComponents/BlueFooter";
import styles from 'styles/pages/press.module.scss';
import Articles from "components/press/Articles";
import PressHeader from "components/press/PressHeader";
import FoundersMessage from "components/press/FoundersMessage";
import FeaturedInBrands from "components/press/FeaturedInBrands";
import { handleApplyNowEvent } from "utils/mixpanelEvents";
import { SyntheticEvent, useState } from "react";

function Press({
    meta,
    header,
    messageSection,
    brandFeatures,
    articles,
}) {

    const [applyNowOpen, setApplyNowOpen] = useState(false);

    const handleSetApplyNowOpen = (e: SyntheticEvent) => {
        if (e) {
            setApplyNowOpen(true);
            handleApplyNowEvent(e.currentTarget.id)
        } else {
            setApplyNowOpen(false);
        }
    }

    return (
        <Layout
            meta={meta}
            applyNowOpen={applyNowOpen}
            handleSetApplyNowOpen={handleSetApplyNowOpen}
        >
            <div className={clsx(styles.container)}>

                <PressHeader
                    data={header}
                />
                <FoundersMessage
                    data={messageSection}
                />
                <FeaturedInBrands
                    data={brandFeatures}
                />
                <Articles
                    articles={articles}
                    styles={styles}
                />
                <ForQueryBox />
                <BlueFooter />
            </div>
        </Layout>
    )
}

export async function getStaticProps() {
    const data: any = await getPressMediaContent();
    return {
        props: {
            meta: data.data.meta,
            header: data.data.header,
            messageSection: data.data.message_section,
            brandFeatures: data.data.brand_features,
            articles: data.data.articles,
        }
    }
}


export default Press;